import { CUSTOM_FIELD_KEYS } from '@/data/customFieldsKeys';

/** Fields we capture from GTM hidden inputs / cookies / URL and send to Pipedrive */
export const ATTRIBUTION_FIELDS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'li_fat_id',
  'msclkid',
  'fbclid',
  'gbraid',
  'wbraid',
  'traffic_channel',
  'first_paid_touch_url',
  'last_paid_touch_url',
  'last_paid_touch_at',
] as const;

export type AttributionField = (typeof ATTRIBUTION_FIELDS)[number];
export type AttributionPayload = Partial<Record<AttributionField, string>>;

const INVALID_VALUES = new Set(['', 'undefined', 'null', 'NaN']);

export function sanitizeAttributionValue(
  value: unknown
): string | undefined {
  if (value == null) return undefined;
  const trimmed = String(value).trim();
  if (!trimmed || INVALID_VALUES.has(trimmed)) return undefined;
  return trimmed;
}

/** Pick non-empty attribution fields from an arbitrary request/form body */
export function pickAttributionFromBody(
  body: Record<string, unknown>
): AttributionPayload {
  const result: AttributionPayload = {};
  for (const key of ATTRIBUTION_FIELDS) {
    const value = sanitizeAttributionValue(body[key]);
    if (value) result[key] = value;
  }
  return result;
}

/** Map attribution payload → Pipedrive deal custom_fields (hash keys) */
export function createAttributionCustomFields(
  attribution: AttributionPayload
): Record<string, string> {
  const customFields: Record<string, string> = {};

  for (const key of ATTRIBUTION_FIELDS) {
    const value = sanitizeAttributionValue(attribution[key]);
    const fieldKey = CUSTOM_FIELD_KEYS[key];
    if (value && fieldKey) {
      customFields[fieldKey] = value;
    }
  }

  return customFields;
}
